"use strict";
/* COMPONENT - c.05.01 - feedback */

import Cookies from "js-cookie";
export default class Feedback {
  constructor(element) {
    this.root = element;
    this.form = this.root.querySelector("form");
    this.yesInput = this.root.querySelector(".js-feedback-yes");
    this.noInput = this.root.querySelector(".js-feedback-no");
    this.feedbackSubmit = this.root.querySelector(".feedback-submit");
    this.feedbackTextarea = this.root.querySelector(".feedback-textarea");
    this.successMessage = this.root.querySelector(".feedback-success");
    this.submitEnv =
      window.location.host === "localhost:8000" || window.location.host === "brc.qa3.rufusleonard.com"
        ? "submitFormTest"
        : "submitForm";
    this.cookieName = "feedback" + encodeURIComponent(window.location.pathname);

    if (this.yesInput && this.noInput && this.form) {
      if (this.isFeedbackSent()) {
        this.successMessage.classList.add("feedback-success--show");
        this.disableInputs();
      }

      this.feedbackValue = this.form.querySelector("[name=useful]");
      this.bindEvents();
    }
  }

  isFeedbackSent() {
    return Cookies.get(this.cookieName) === "true";
  }

  disableInputs() {
    this.yesInput.disabled = true;
    this.noInput.disabled = true;
  }

  enableInputs() {
    this.yesInput.disabled = false;
    this.noInput.disabled = false;
  }

  yesClick(event) {
    event.preventDefault();
    if (!this.isFeedbackSent()) {
      this.feedbackValue.value = "yes";
      this.noInput.classList.remove("feedback-link--selected");
      this.noInput.setAttribute("aria-expanded", "false");
      this.yesInput.classList.add("feedback-link--selected");
      this.successMessage.classList.remove("feedback-success--show");
      this.feedbackTextarea.classList.remove("feedback-textarea--show");
      this[this.submitEnv](this.form, this.formResponse, event);
      this.disableInputs();
    } else {
      this.successMessage.classList.add("feedback-success--show");
      this.disableInputs();
    }
  }

  noClick(event) {
    event.preventDefault();
    if (!this.isFeedbackSent()) {
      this.feedbackValue.value = "no";
      this.yesInput.classList.remove("feedback-link--selected");
      this.noInput.classList.add("feedback-link--selected");
      this.noInput.setAttribute("aria-expanded", "true");
      this.successMessage.classList.remove("feedback-success--show");
      this.feedbackTextarea.classList.add("feedback-textarea--show");
      this.feedbackSubmit.classList.add("feedback-submit--show");
    } else {
      this.successMessage.classList.add("feedback-success--show");
      this.disableInputs();
    }
  }

  formResponse(xhr) {
    let response = xhr.status;

    this.noInput.setAttribute("aria-expanded", "false");
    this.feedbackSubmit.classList.remove("feedback-submit--show");

    if (response != 200) {
      console.log("Error submitting feedback");
      this.enableInputs();
    } else {
      this.successMessage.classList.add("feedback-success--show");
      Cookies.set(this.cookieName, "true");
    }
  }

  submitFormTest(form, callback, event) {
    event.preventDefault();

    callback.call(this, {
      status: 200,
    });
  }

  submitForm(form, callback, event) {
    event.preventDefault();
    this.disableInputs();

    var url = form.action,
      xhr = new XMLHttpRequest();

    var params = [].filter
      .call(form.elements, function (el) {
        return true;
      })
      .filter(function (el) {
        return !!el.name;
      })
      .filter(function (el) {
        return !el.disabled;
      })
      .map(function (el) {
        return encodeURIComponent(el.name) + "=" + encodeURIComponent(el.value);
      })
      .join("&");

    xhr.open("POST", url);
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhr.onload = callback.bind(this, xhr);
    xhr.send(params);
  }

  bindEvents() {
    this.yesInput.addEventListener("click", this.yesClick.bind(this));
    this.noInput.addEventListener("click", this.noClick.bind(this));
    this.form.addEventListener("submit", this[this.submitEnv].bind(this, this.form, this.formResponse));
  }
}
